import React, { useState, useEffect } from 'react';
import { externalLinks } from '../data/mock';
import { Phone } from 'lucide-react';

const FloatingCallButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling 500px
      setIsVisible(window.scrollY > 500);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <a
      href={externalLinks.phone}
      className="fixed bottom-24 lg:bottom-8 right-4 z-50 flex items-center justify-center w-14 h-14 bg-[#00FFD1] rounded-full shadow-lg hover:scale-110 transition-transform duration-300 group"
      aria-label="전화하기"
    >
      <Phone size={24} className="text-black" />
      
      {/* Pulse effect */}
      <span className="absolute inset-0 rounded-full bg-[#00FFD1] animate-ping opacity-30" />
      
      {/* Tooltip on hover */}
      <span className="absolute right-full mr-3 px-3 py-1 bg-black text-white text-sm whitespace-nowrap rounded opacity-0 group-hover:opacity-100 transition-opacity">
        010-5446-8087
      </span>
    </a>
  );
};

export default FloatingCallButton;